module.exports = __webpack_public_path__ + "2b6afb5d2120e5b24eec46df279cf44c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bo.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bo.svg
// module chunks = 0